import { Module } from "vuex";
import { flowEdit } from "@core/store/modules/webmaster/flows/flowEdit";

export const flow: Module<any, any> = {
  namespaced: true,
  modules: {
    edit: flowEdit
  }
};
